'use client';
import { createContext } from 'react';
import * as React from 'react';
import type { LinkProviderProps } from 'src/types';

export const LinkContext = createContext<
  LinkProviderProps['CustomLink'] | null
>(null);

export const LinkProvider: React.FC<LinkProviderProps> = ({
  CustomLink,
  children,
}) => (
  <LinkContext.Provider value={CustomLink}>{children}</LinkContext.Provider>
);
